import * as React from 'react';
import * as Images from 'pos/Images';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, Res, PriceListDTO } from 'core/api';
import { BackActionButton, Content, Footer, Header, PhoneOnly, PosScreen } from 'pos/ui';
import { RestaurantFacade } from 'pos/facades';
import * as SalesStore from '../SalesStore';
import { CustomerDisplay } from 'pos/services';
import { Modal } from 'core/ui-next/modal';
import { VStack, Text } from '@chakra-ui/react';
import { CustomList, SvgIcon } from 'core/ui-next';

type Props = {
	existingPriceLists: PriceListDTO[];
	originalPriceList: PriceListDTO;
} & Modal.Actions<void>;

function SetTicketPriceList(props: Props): React.JSX.Element {

	const { existingPriceLists, originalPriceList, close, cancel } = props;

	const onSelectPriceType = async (priceList: PriceListDTO) => {
		await SalesStore.setTicketPriceList(priceList.Id);
		await CustomerDisplay.displayPriceList(SalesStore.getTicket());
		close();
	};

	const onCancel = React.useCallback(async () => cancel(), [cancel]);

	return <PosScreen screenId={'SET_TICKET_PRICE_LIST'} size={'small'}>
		<Header title={Res.Web.SET_TICKET_PRICE_LIST()} onClose={cancel} />
		<Content>
			<VStack paddingX={'6'} paddingY={'9'} h='full' w='full' gap={'6'}>
				<VStack gap={'4'} justifyItems={'center'} w='full'>
					<SvgIcon src={Images.ConfigurePriceList} w={'12'} h={'12'} />
					<Text fontSize={'md'} fontWeight={'bold'}>
						{Res.Web.SET_TICKET_PRICE_LIST_LBL()}
					</Text>
				</VStack>
				<CustomList
					items={existingPriceLists}
					itemKey={pl => pl.Id}
					itemText={pl => pl.Name}
					onSelectItem={onSelectPriceType}
					selectedItemKey={originalPriceList.Id}
				/>
			</VStack>
		</Content>
		<Footer>
			<PhoneOnly>
				<BackActionButton action={onCancel} />
			</PhoneOnly>
		</Footer>
	</PosScreen>;
}

declare global {
	interface CommandType {
		setTicketPriceList: () => Promise<Result>
	}
}

Command.register('setTicketPriceList', Preconditions.ensure(Permission.Ticket_ChangePriceList), async (): Promise<Result> => {
	const ticket = SalesStore.getTicket();
	const priceLists = await RestaurantFacade.getAllPriceListsByTicketId(ticket.Id);
	const defaultPriceList: PriceListDTO = {
		Id: 0,
		Name: Res.Web.SET_TICKET_PRICE_LIST_DEFAULT_PRICE_LIST_ITEM(),
		IsDefault: true
	};
	const existingPriceLists = [defaultPriceList, ...priceLists];

	return await Modal.show(SetTicketPriceList, { originalPriceList: ticket.PriceList, existingPriceLists });
});